export const enum ControlType {
    Radio = 'Radio',
    Checkbox = 'Checkbox',
    Text = 'Text',
    Phone = 'Phone',
    Email = 'Email',
    Date = 'Date',
    Number = 'Number',
    Box = 'Box',
  }